<div class="panel-body ">
   <div class="col-sm-12 panel panel-default panel-margin-bottom panel-margin-top">
    <div class="panel-body ">
      <div class="row table-responsive">
	   <table id="attorney-table" class="table table-condensed table-striped">
		<thead>
			<tr>
				<th id="V122c">
					<span class="field-code ">V122c json='attorneys.name'</span>
					Name
				</th>
				<th id="V121c">
					<span class="field-code ">V121c json='attorneys.barNumber'</span>
						North Carolina State Bar Number
					</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let attorney of civilCase.getAttorneyList(); let i = index">
				<td id="{{'civil-caseDetails-attorneys-' + i + '-name' }}">{{attorney.getAttorneyName()}}</td>
				<td id="{{'civil-caseDetails-attorneys-' + i + '-barNumber'}}">{{attorney.getBarNumber()}}</td>
			</tr>
		</tbody>
	  </table>
    </div>
   </div>
  </div>
</div>


// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/case-view/civil/attorneys/attorneys.component.html